import faker from 'faker';
import moment from 'moment';

export default Array(10)
  .fill(0)
  .map((_, index) => {
    return {
      id: index,
      medicaoId: index,
      contratoId: index,
      numeroBm: faker.random.number({ min: 1000, max: 5000 }),
      numeroContrato: faker.random.number({ min: 1000, max: 5000 }),
      periodoInicio: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
      periodoFim: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
      fornecedor: faker.name.findName(),
      gestorMrn: faker.name.findName(),
      admContrato: faker.name.findName(),
      houveNãoConformidade: faker.lorem.word(),
      nivelConformidadeMedicao: index,
      createdAt: moment(faker.date.recent(10)).format('DD/MM/YYYY'),
    };
  });
